import { ResetPasswordPage } from '@pages/resetPassword';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta('Сброс пароля', 'Сброс пароля');
}

export default function Page() {
  return <ResetPasswordPage />;
}
